import React from 'react';

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Link from '@material-ui/core/Link';
import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/core/styles';

import MatrixCard from 'matrix-card';

import arithmetixCrushImg from './images/logo512.png';
import appleImg from './images/download-on-the-app-store.svg';
import googleImg from './images/google-play.png';

const c_backgroundColor = "#000";
// const c_iosFreeDownloadLink = "https://apps.apple.com/tr/app/arithmetix-crush/id1512566250";
// const c_androidFreeDownloadLink = "https://play.google.com/store/apps/details?id=com.computatus.arithmetixcrush";
const c_iosProDownloadLink = "https://apps.apple.com/tr/app/arithmetix-crush/id1523171418";
const c_androidProDownloadLink = "https://play.google.com/store/apps/details?id=com.computatus.arithmetixcrush.noads";

const pageTextTheme = createMuiTheme({
	palette: {
		primary: { main: "#f6feff" },
		secondary: { main: "#ffe3ff" },
		downloadPageText: { main: "#FFFFFF" },
	},
});

function Copyright() {
	return (
		<ThemeProvider theme={pageTextTheme}>
			<Typography variant="body2" color="secondary" align="center">
				{'Copyright © '}<Link color="inherit" href="https://computatus.com/">Computatus</Link>{` ${new Date().getFullYear()}.`}
			</Typography>
		</ThemeProvider>
	);
}

const useStyles = makeStyles(theme => ({
	logoContainer: {
		width: '100%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	logoImage: {
		width: '62%',
	},
	storeContainer: {
		height: '40px',
	},
	heroContent: {
		backgroundColor: c_backgroundColor,
		padding: theme.spacing(0, 0, 0),
		height: 'auto',
		minHeight: '100vh',
	},
	heroButtons: {
		justifyContent: 'center',
		alignItems: 'center',
	},
	childrenContainer: {
		width: '100%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	heroContainer: {
		width: '100%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	footer: {
		backgroundColor: c_backgroundColor,
		padding: theme.spacing(6),
	},
}));

export default function DownloadPage(props) {
	const classes = useStyles();

	return (
		<React.Fragment>
			<main>
				{/* Hero unit */}
				<div className={classes.heroContent}>
					<Container maxWidth="sm">
						<div className={classes.logoContainer} >
							<MatrixCard
								id={"my-id-1"}
								matrixText={"0123456789"}
								delay={100}
								backgroundColor={"rgba(9,9,9, 0.1)"}
								textFontSize={"16"}
								textMainColor={"#00FF00"}
								textAlternateColorRatio={0.1}
								textAlternateColorList={["#00F000", "#00EA00", "#00E000", "#00D600"]}
								styleOverrideForCanvas={{
									backgroundColor: "#00FF00",
								}}
								styleOverrideForChildrenDiv={{
									backgroundColor: "#00000000",
									display: 'flex',
									justifyContent: 'center',
									alignItems: 'center',
								}}
								canvasSize={{ width: '480', height: '208' }}
							>
								<img className={classes.logoImage} src={arithmetixCrushImg} alt="arithmetixCrush" />
							</MatrixCard>
						</div>

						<div className={classes.childrenContainer}>
							{props.children}
						</div>
						<div className={classes.heroContainer}>
							<MatrixCard
								id={"my-id-3"}
								matrixText={"0123456789"}
								delay={100}
								backgroundColor={"rgba(9,9,9, 0.1)"}
								textFontSize={"16"}
								textMainColor={"#0000FF"}
								textAlternateColorRatio={0.1}
								textAlternateColorList={["#0000FF", "#0000EA", "#0000E0", "#0000D6"]}
								styleOverrideForCanvas={{
									backgroundColor: "#0000FF",
									display: 'flex',
									justifyContent: 'center',
									alignItems: 'center',
								}}
								styleOverrideForChildrenDiv={{
									backgroundColor: "#00000000",
									display: 'flex',
									justifyContent: 'center',
									alignItems: 'center',
								}}
								canvasSize={{ width: '480', height: '208' }}
							>
								<div className={classes.heroButtons}>
									<Grid container spacing={2} justify="center">
										<Grid item>
											<Button onClick={() => window.location.href = c_iosProDownloadLink}>
												<div className={classes.logoContainer}>
													<img className={classes.storeContainer} src={appleImg} alt="Download for iOS" />
												</div>
											</Button>
										</Grid>
										<Grid item>
											<Button onClick={async () => {
												// await alert("Available only for early access users for now...");
												window.location.href = c_androidProDownloadLink;
											}}>
												<div className={classes.logoContainer}>
													<img className={classes.storeContainer} src={googleImg} alt="Download for Android" />
												</div>
											</Button>
										</Grid>
									</Grid>
								</div>
							</MatrixCard>
						</div>
					</Container>
				</div>
			</main>
			<footer className={classes.footer}>
				<Copyright />
			</footer>
		</React.Fragment>
	);
}

